export default __webpack_public_path__ + "static/media/alert_sound.8fe3317f.wav";